import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

export const LegalContainer = styled(Box)(() => ({
  '& p': {
    lineHeight: 1.91,
    marginBottom: 20,
    '&:first-of-type': {
      marginTop: 25,
    },
  },
  '& button': {
    fontSize: 14,
    textDecoration: 'none',
    color: '#266dcc',
  },
}))
